// extracted by mini-css-extract-plugin
export default {"row":"InformationTab_row__bmYUK","CommingSoon":"InformationTab_CommingSoon__fRgLo"};